import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

import NewsHeader from "./components/NewsHeader";
import Footer from "./components/Footer";
import Home from "./components/Home";
import Politic from "./components/Politic";
import Business from "./components/Business";
import Technology from "./components/Technology";
import Sport from "./components/Sport";
import Entertainment from "./components/Entertainment";
import Health from "./components/Health";
import Contact from "./components/Contact";
import Login from "./components/Login";
import EPaper from "./components/EPaper";
import "bootstrap-icons/font/bootstrap-icons.css";

// import Register from "./components/Register";


// ✅ Admin Pages
import AdminLayout from "./Admin/AdminLayout";
import Dashboard from "./Admin/Dashboard";
import AddNews from "./Admin/AddNews";
import ManageNews from "./Admin/ManageNews";
import User from "./Admin/User";

function LayoutWrapper() {
  const location = useLocation();

  // Hide header/footer on admin routes
  const isAdminRoute = location.pathname.startsWith("/admin");

  return (
    <>
      {!isAdminRoute && <NewsHeader />}

      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/politic" element={<Politic />} />
        <Route path="/business" element={<Business />} />
        <Route path="/technology" element={<Technology />} />
        <Route path="/sport" element={<Sport />} />
        <Route path="/entertainment" element={<Entertainment />} />
        <Route path="/health" element={<Health />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/login" element={<Login />} />
        <Route path="/epaper" element={<EPaper />} />

        {/* <Route path="/register" element={<Register />} /> */}

        {/* ✅ Admin Nested Routes */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="add-news" element={<AddNews />} />
          <Route path="manage-news" element={<ManageNews />} />
          <Route path="user" element={<User />} />




        </Route>
      </Routes>

      {!isAdminRoute && <Footer />}
    </>
  );
}

function App() {
  return (
    <Router>
      <LayoutWrapper />
    </Router>
  );
}

export default App;